import React, { useCallback } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import BadgeComponent from "components/core/badge/badge-component";
import { HEADER_SUBMENU_LINK_CLICKED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import PictureComponent from "components/core/picture/picture-component";
import classnames from "classnames";
import { ICON_TYPES } from "segments/desktop/header/layouts/base-header/base-header-service";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import colors from "styles/colors";
import { componentStyles } from "./header-menu-section-item-component.scss";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import MondayMarkupLanguageComponent
  from "client/components/system/monday-markup-language/monday-markup-language-component";

const HeaderMenuSectionItemComponent = (props) => {
  const {
    icon: Icon,
    iconType,
    iconColor,
    imageSrc,
    title,
    description,
    url,
    isPopular,
    translate,
    badgeText,
    badgeColorName,
    badgeTextColorName,
    openInNewTab,
    button,
    menuId,
    sectionId
  } = props;

  const onClick = useCallback(
    (e) => {
      const isKeyboardEvent = e?.screenX === 0 && e?.screenY === 0;
      trackEvent(HEADER_SUBMENU_LINK_CLICKED, { kind: url, info1: isKeyboardEvent ? "keyboard" : "mouse", info2: menuId, info3: sectionId });
    },
    [url]
  );

  return (
    <a
      className="header-menu-section-item-component"
      href={url}
      onClick={onClick}
      target={openInNewTab ? "_blank" : "_self"}
    >
      <div
        className={classnames("header-menu-item-content", {
          "has-image-instead-title": !!imageSrc,
          "no-description": !description
        })}
      >
        {Icon && (
          <Icon
            className={classnames("menu-item-title-icon", iconType)}
            style={{ "--icon-color": colors[iconColor || WORK_OS_IRIS_COLOR_NAME] }}
          />
        )}
        {imageSrc && <PictureComponent src={imageSrc} />}
        <div className="menu-item-text-wrapper">
          <div className="menu-item-title-wrapper">
            <span className="menu-item-title">{translate(title)}</span>
            {isPopular && (
              <div className="new-badge-component-wrapper">
                <BadgeComponent badgeText={translate(badgeText)} badgeColorName={badgeColorName} badgeTextColorName={badgeTextColorName}/>
              </div>
            )}
          </div>

          <span className="menu-item-description"><MondayMarkupLanguageComponent text={translate(description)} /></span>
          {button && <div className="menu-item-description-button">
              <SecondaryButton buttonText={translate("header.menuItem.button.text")} url={url} />
            </div>
          }
        </div>
      </div>

      <style jsx>{componentStyles}</style>
    </a>
  );
};

export default withGenericConfig(HeaderMenuSectionItemComponent);

HeaderMenuSectionItemComponent.defaultProps = {
  iconType: ICON_TYPES.outline
};
